// extracted by mini-css-extract-plugin
export default {"container":"hint_container__b09Wq","list":"hint_list__qYnEx","hint":"hint_hint__yUgYN","color":"hint_color__PJDus","text":"hint_text__M5R+w"};